
import { createContext } from "react";

const portfolioContext = createContext();

export default portfolioContext;